import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { PercentInputModule } from '@liberty-financial/ng-components';

import { SparkSharedPercentageComponent } from './percentage.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, PercentInputModule],
  declarations: [SparkSharedPercentageComponent],
  exports: [SparkSharedPercentageComponent]
})
export class SparkSharedPercentageModule {}
